import React, { Fragment } from 'react';
import Lightbox from 'react-images';
import { Splide, SplideSlide } from '@splidejs/react-splide';
// import '@splidejs/splide/dist/css/splide.min.css';

const LightboxImages = props => (
    !props.images || props.images.length < 1 ? <Fragment /> :
    <Fragment>
        <div className="row product-images">
            <div className="columns">
                <figure className={`product-detail__image-container ${props.classes}`} data-title={props.title}>
                    {!!props.tags.length && 
                        <div className='product-detail__tag-wrapper'>
                            {props.tags.map((tag) => 
                                <div class="product-detail__tag" style={{ color: `${tag.TextColor}`, background: `${tag.Color}` }} key={tag.Name}>
                                    {tag.Name}
                                </div>
                            )}
                        </div>
                    }
                    <a data-src={props.images[0].src} itemProp="url" onClick={() => props.onClickThumbnail(0)} className="product-image">
                        <img className="product-detail__image--main" itemProp="image" src={props.thumbnails[0].src} />
                    </a>
                </figure>
                <div className="row">
                    <Splide options={ {
                            perPage : 4,
                            width: 600,
                            fixedWidth: 110,
                            fixedHeight: 110,
                            pagination: false,
                            arrows: props.images.length > 4
                            }}>
                        {props.images.map((image, index) => (
                            index > 0 &&
                            <SplideSlide key={index}>
                                <div className="product-detail__image-container" key={index}>
                                    <a data-src={image.src} itemProp="url" onClick={() => props.onClickThumbnail(index)} className="product-image">
                                        <img className="product-detail__image--alter" itemProp="image" src={props.thumbnails[index].src} height="110" width="110" />
                                    </a>
                                </div>
                            </SplideSlide>
                            
                        ))}
                    </Splide>
                </div>
            </div>
        </div>
        <Lightbox 
            showThumbnails={true}
            showImageCount={false}
            {...props}
        />
    </Fragment>
)

export default LightboxImages;